// import { Spin } from 'antd'
import React, { useEffect } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { addUserToLocalStorage } from '../../../../utils/utils'
import { Backdrop, Box } from '@mui/material'
import LoaderIcon from '../../../../resources/img/svg/loader.svg'
import { decryptResponse } from '../../../../utils/customAxios'

const particularUserLogin = (id, token) => {
	return axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/signAsUser/${id}`, {
		headers: {
			authorization: `Bearer ${token}`,
		},
	})
}

const LoginAsAdmin = () => {
	const { token, sponserId } = useParams()
	const navigate = useNavigate()

	const handleGetUserLoginDetails = async (sId, token) => {
		let responseJson = await particularUserLogin(sId, token)
		if (responseJson.status === 200) {
			if (responseJson && responseJson.data) {
				if (process.env.REACT_APP_ENV === 'production') {
					const decryptedResponse = decryptResponse(
						responseJson.data,
						process.env.REACT_APP_RESPONSE_CRYPTO_HEX_KEY,
						process.env.REACT_APP_RESPONSE_CRYPTO_IV_KEY
					)
					responseJson.data = decryptedResponse
				}
				if (responseJson.data.status === 0) {
					console.error(responseJson.data.message)
				} else if (responseJson.data.status === 1) {
					addUserToLocalStorage(responseJson?.data)
					navigate('/')
				} else {
					console.error(responseJson.data.message)
				}
			}
		}
	}

	useEffect(() => {
		if (token && sponserId) {
			handleGetUserLoginDetails(sponserId, token)
		}
	}, [])

	if (!token) <Navigate to='/Signin' />
	return (
		<Box>
			<Backdrop
				style={{ zIndex: 99999 }}
				classes={{
					root: 'MuiBackdrop-root-loader',
				}}
				open={true}
			>
				<img src={LoaderIcon} alt='Loading...' style={{ width: '250px', height: '250px' }} />
			</Backdrop>
		</Box>
	)
}

export default LoginAsAdmin
